// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__EpAMZ","meals-appear":"AvailableMeals_meals-appear__3m1oK"};